// ---------------------------------------------------------------------------
// Pure JS helpers shared across the Analyze13 feature
// ---------------------------------------------------------------------------

/** Strip HTML tags and decode common HTML entities for safe plain-text rendering */
export function stripHtml(html) {
  if (!html || typeof html !== 'string') return html;
  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || '').trim();
}

/** LCS-based word-level diff — returns segments tagged {text, added} */
export function diffWords(before, after) {
  const tok = (s) => s.split(/(\s+)/);
  const a = tok(before || '');
  const b = tok(after || '');
  const m = a.length, n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--)
    for (let j = n - 1; j >= 0; j--)
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const segs = [];
  let i = 0, j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) { segs.push({ text: b[j], added: false }); i++; j++; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { i++; }
    else { segs.push({ text: b[j], added: true }); j++; }
  }
  while (j < n) { segs.push({ text: b[j], added: true }); j++; }
  return segs;
}

/** Trigger a CSV file download */
export function downloadCsv(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;
  const lines = [headers.map(esc).join(','), ...rows.map((r) => r.map(esc).join(','))];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

/** Parse HH:MM:SS / MM:SS / raw-seconds duration strings to seconds */
export function parseDurationSecs(d) {
  if (!d) return null;
  const parts = String(d).split(':').map(Number);
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  const n = Number(d);
  return isNaN(n) ? null : n;
}
